import { render, staticRenderFns } from "./addShippingInvoice.vue?vue&type=template&id=4f1402b3&scoped=true&"
import script from "./addShippingInvoice.vue?vue&type=script&lang=js&"
export * from "./addShippingInvoice.vue?vue&type=script&lang=js&"
import style0 from "./addShippingInvoice.vue?vue&type=style&index=0&id=4f1402b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1402b3",
  null
  
)

export default component.exports